import { setDeliveryMethod } from "action/shopping-cart/setDeliveryMethod";
import classNames from "classnames";
import DeliveryInStorePickupIcon from "component/design-system/badge/DeliveryInStorePickupIcon";
import DeliveryRapidShippingIcon from "component/design-system/badge/DeliveryRapidShippingIcon";
import DeliveryShippingIcon from "component/design-system/badge/DeliveryShippingIcon";
import Popover from "component/design-system/popover/Popover";
import { DELIVERY_METHODS } from "constant/action-constants";
import { RootState } from "interfaces/generics.type";
import { DELIVERY_TIME_FORMATS } from "modules/shopping-cart/helper/constant";
import { useTranslation } from "next-i18next";
import Link from "next/link";
import { useRouter } from "next/router";
import { useDispatch, useSelector } from "react-redux";
import HideIf from "util/HideIf";
import { RadioInputContainer } from "../../../component/design-system/RadioInput";
import { currency } from "../../../util/helper/currency";
import { getDeliveryMethodDetails } from "../../../util/helper/getDeliveryMethodDetails";
import { isDeliveryMethodUnAvailable } from "../../../util/helper/isDeliveryMethodUnAvailable";
import { isPickUpDeliveryAvailable } from "../../../util/helper/isPickUpDeliveryAvailable";
import PickUpOnlyWarning from "./PickUpOnlyWarning";
import styles from "./product-delivery.module.scss";

const DeliveryOptions = (props: any) => {
  const {
    pickupLocation, name = "delivery", productDeliveryOptions,
  } = props;

  if (!productDeliveryOptions) {
    return null;
  }

  const { pickUpAvailable, shipmentAvailable, deliveryAvailable } = isPickUpDeliveryAvailable(productDeliveryOptions);
  const { pickupDetails = {}, deliveryDetails = {}, shipmentDetails = {} } = getDeliveryMethodDetails(productDeliveryOptions) || {};

  const dispatch = useDispatch();
  const { t } = useTranslation(["product", "common"]);
  const router = useRouter();
  const { locale } = router;

  const {
    minEstDeliveryTime, maxEstDeliveryTime, deliveryTimeFormat, deliveryCost: rapidDeliveryCost,
  } = deliveryDetails;
  const { deliveryCost: shipmentCost } = shipmentDetails;

  const { postalCode, deliveryMethod = DELIVERY_METHODS.SHIPPING } = useSelector((store: RootState) => store.shoppingCart);
  const deliveryShortKey = DELIVERY_TIME_FORMATS[deliveryTimeFormat] === DELIVERY_TIME_FORMATS.DAY ? "s_day_delivery" : "s_hour_delivery";
  const estimatedDeliveryText = `${t(deliveryShortKey, { minTime: minEstDeliveryTime, maxTime: maxEstDeliveryTime })} `;
  const pickupShortKey = DELIVERY_TIME_FORMATS[pickupDetails.deliveryTimeFormat] === DELIVERY_TIME_FORMATS.DAY ? "s_pickup_day" : "s_pickup_hour";
  const estimatedPickupText = t(pickupShortKey, { minTime: pickupDetails.minEstDeliveryTime, maxTime: pickupDetails.maxEstDeliveryTime });
  // const isPickupOnly = true;

  return (
    <ul className={`m-b-0 m-t-10 ${styles.delivery_options}`}>

      {/* <HideIf show={!shipmentAvailable}> */}

      <li
        className={classNames(
          {
            [styles.selected_delivery]: shipmentAvailable && deliveryMethod === DELIVERY_METHODS.SHIPPING,
            [styles.disabled]: !shipmentAvailable,
          },
        )}
        onClick={() => {
          if (shipmentAvailable) { dispatch(setDeliveryMethod(DELIVERY_METHODS.SHIPPING)); }
        }}

      >
        <div className="d-flex justify-content-between align-items-center">

          <RadioInputContainer className="radio">

            <label>

              <DeliveryShippingIcon />

              <span className="bold">{t("Shipping", { ns: "common" })}</span>

              <input
                name={name}
                type="radio"
                value={DELIVERY_METHODS.SHIPPING}
                checked={shipmentAvailable && deliveryMethod === DELIVERY_METHODS.SHIPPING}
              />

              <span className="checkmark delivery-option-checkmark" />
            </label>
          </RadioInputContainer>
          <div className="bold">
            <HideIf show={shipmentCost}>
              {currency(shipmentCost, locale)}
            </HideIf>
          </div>
        </div>
        <HideIf show={!shipmentAvailable}>
          <div className="d-flex m-r-5">
            <span className={styles.unavailable_text} />
            <Popover
              component={(
                <div className={styles.popover_content_text}>
                  We apologize this item is not available for shipping at this time.
                  However, this item may be pickedUp at a Partsavatar store.
                  If the item is not in stock at your local store,
                  then your store associates can order the item for you.
                  We apologize for the inconvenience.
                </div>
              )}
              placement="bottom"
            >
              <span className={styles.popover_trigger_text} />

            </Popover>
          </div>
        </HideIf>
        <HideIf show={shipmentAvailable && deliveryMethod === DELIVERY_METHODS.SHIPPING}>

          <div className="row">

            <div className="col-md-1" />

            <div className="col-md-11">

              <div className="color-green">

                <b>{t("free_shipping_over", { value: "75" })}</b>
              </div>
            </div>
          </div>
        </HideIf>
      </li>
      {/* </HideIf> */}

      <HideIf show={deliveryAvailable}>

        <li
          className={classNames(
            {
              [styles.selected_delivery]: deliveryMethod === DELIVERY_METHODS.DELIVERY,
            },
          )}
          onClick={() => dispatch(setDeliveryMethod(DELIVERY_METHODS.DELIVERY))}
        >

          <div className="d-flex justify-content-between align-items-center">

            <div>

              <RadioInputContainer className="radio">

                <label>

                  <DeliveryRapidShippingIcon />

                  <span className="bold">{t("Rapid Home Delivery", { ns: "common" })}</span>

                  <input
                    name={name}
                    type="radio"
                    value={DELIVERY_METHODS.DELIVERY}
                    checked={deliveryMethod === DELIVERY_METHODS.DELIVERY}
                  />

                  <span className="checkmark delivery-option-checkmark" />
                </label>
              </RadioInputContainer>
            </div>

            <div className="bold">
              <HideIf show={rapidDeliveryCost}>
                {currency(rapidDeliveryCost, locale)}
              </HideIf>
            </div>

            {/* <div className={`col-md-10 col-lg-10 col-sm-10 col-xs-10 p-lr-0 ${styles.vcenter}`}>
              <div className="d-flex justify-content-between">
                <div className="bold">Rapid Home Delivery</div>
                <div className="bold">$CAD 6.99</div>
              </div>
            </div> */}
          </div>

          <HideIf show={deliveryMethod === DELIVERY_METHODS.DELIVERY}>

            <div className="row">

              <div className="col-md-1" />

              <div className="col-md-11">
                {/* Todo: number of days */}

                <div>
                  {estimatedDeliveryText}
                  <b>{postalCode}</b>
                </div>

                <Link href="/rapid-delivery" className="color-blue blue-hover bold">

                  {t("How it Works?")}
                </Link>
              </div>
            </div>
          </HideIf>
        </li>
      </HideIf>

      <HideIf show={pickUpAvailable}>

        <li
          className={classNames(
            {
              [styles.selected_delivery]: deliveryMethod === DELIVERY_METHODS.PICKUP,
            },
          )}
          onClick={() => dispatch(setDeliveryMethod(DELIVERY_METHODS.PICKUP))}
        >
          <div className="d-flex justify-content-between align-items-center">
            <div>
              <RadioInputContainer className="radio">
                <label>
                  <DeliveryInStorePickupIcon />

                  <span className="bold">{t("Buy Online & Pick Up In Store")}</span>

                  <input
                    name={name}
                    type="radio"
                    value={DELIVERY_METHODS.PICKUP}
                    checked={deliveryMethod === DELIVERY_METHODS.PICKUP}
                  />
                  <span className="checkmark delivery-option-checkmark" />
                </label>
              </RadioInputContainer>
            </div>

            <div className="color-green bold">{t("FREE", { ns: "common" })}</div>
          </div>
          <HideIf show={deliveryMethod === DELIVERY_METHODS.PICKUP}>
            <div className="row">
              <div className="col-md-1" />
              <div className="col-md-11">
                <div className="color-dark-grey">
                  {`${t("s_pickup_location")} `}
                  <b className="color-black">{pickupLocation}</b>
                </div>
                <div>
                  {`${estimatedPickupText} `}
                  <a href="/in-store-pickup" target="_blank">
                    <b className="color-blue blue-hover">
                      {t("How pickup Works?")}
                    </b>
                  </a>
                </div>
              </div>
            </div>
          </HideIf>
        </li>
      </HideIf>

      {/* For Postal Code H3B 1A6
      URL => http://localhost:3000/bosch-battery-s6508b
       */}
      <HideIf show={isDeliveryMethodUnAvailable(productDeliveryOptions)}>

        <PickUpOnlyWarning
          classNames="m-t-20"
        />
      </HideIf>
    </ul>
  );
};

export default DeliveryOptions;
